import * as React from 'react';
import { useTheme } from 'styled-components';
export const SvgCircleslash = (props) => {
    /**
     * React component automatically generated from the .svg file.
     * Do not make any changes here. Use the template file or svgr settings.
     */
    const themeColor = useTheme().colors.primary.medium;
    props = Object.assign({ fill: themeColor, role: 'presentation' }, props);
    return (React.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM4.96875 6.38281C3.73712 7.92249 3 9.87498 3 12C3 16.9706 7.02944 21 12 21C14.1247 21 16.0757 20.2616 17.6152 19.0303L4.96875 6.38281ZM12 3C9.87498 3 7.92249 3.73712 6.38281 4.96875L19.0303 17.6162C20.2619 16.0766 21 14.125 21 12C21 7.02944 16.9706 3 12 3Z" })));
};
